module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Light.9bc693a2.ttf";